<template>
  <div class="news">
    <img :src="bannerImg" class="bannerImg" />
    <an-child>
      <div slot="c_left" class="left_nav">
      	<h3 class="title-color"><a>{{$store.state.langData.responsibility}}</a></h3>
        <ul>
          <li v-for="(item,index) in cleft" :key="index">
            <router-link :to="'/responsibility'+'?type='+item.type" exact>{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div slot="c_right">
      <div class="bread d-flex">
          <h3 class="flex-auto"><a class="text-blue">{{title}}</a></h3>
          <div class="text-gray_dark d-flex">
            <span><img src="@/assets/images/p.png" class="pic"></span>
            {{$store.state.langData.nowAddress}}：           
            <router-link :to="'/responsibility?type='+type">{{$store.state.langData.responsibility}}</router-link>>
            <a>{{title}}</a>
          </div>
      </div>
          <div v-html="content"></div>
      </div>
    </an-child>
  </div>
</template>

<script>
import { getBanner } from "@/api";
import { getCommunityResponsList,getCommunityResponsClassify } from "@/api/hjy";
export default {
  name: "News",
  data(){
        return {
            cleft:[],
            bannerImg:'',//banner
            content:'',
            bannerShow:false,
        }
   },
   methods: {
      //获取分类
      getCommunityResponsClassify(){
        getCommunityResponsClassify()
        .then(res=>this.cleft.push(...res.data))
        .catch(e=>console.log(e))
      },
			// 获取banner
			getBannerImg() {
				getBanner({
					params: 5,
          ad_type: 5
        })
        .then(res => {
          this.bannerImg = res.list[0].imageUrl;
          this.bannerShow = true;
				});			
			},
			getCommunityResponsList() {
        this.content = '';
				getCommunityResponsList({
						type: this.$route.query.type,
					})
					.then(res => {
            if(res.data.data.length>0){
              this.content = res.data.data[0].content;
            }
          })
          .catch(e=>console.log(e));;
      },
    },
    mounted(){
      this.getBannerImg();
      this.getCommunityResponsClassify();
    },
		computed: {
			title() {
				let type = this.$route.query.type;
				let t = '';
				this.cleft.map(n => {
					if(n.type == type) {
						t = n.name;
						return;
					}
				});
				this.getCommunityResponsList();
				return t;
      },
      type(){
        return this.cleft.length>0?this.cleft[0].type:''
      }
		}
};
</script>
<style lang="stylus">
  .bannerImg
    width 1200px
    height auto 
    margin 15px auto !important
    display block
  .news
    padding-bottom 88px
	.news_events
    .sec_box
        padding-left 20px
    h2
        font-weight normal
        margin-bottom 12px
        color #ED822A
        font-size 36px
        span
            color #1278C6
    .news_list
        .news_list_item
            padding 22px 0
            border-bottom 1px solid #89BAE0
        img 
            width 240px
            height 166px  
        .e_time
            color #ED822A
        h5
            color #1278C6
            font-size 16px
            margin 12px 0
        .intro
            color #222222
            line-height 24px   
    .pagenation
        margin 58px 0   
</style>